<template>
  <div class="NavList">
    <div class="NavList_center">
      <div class="video_box" v-if="this.$route.params.type == 1">
        <!--card区-->
        <div class="home_KpVideo_Card">
          <div class="KpVideo_Card_list">
            <div v-for="item in DoctorListData" @click="handleTGoShow(item.id)" class="item_Card_list">
              <div class="card_img">
                <img :src="item.coverUrl" alt="">
                <div>{{item.title}}</div>
              </div>
              <div class="card_name">
                <div>{{item.doctorName}}</div>
                <span>{{item.hospitalName}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="audio_box" v-if="this.$route.params.type == 2">
        <!--card区-->
        <div class="voice_list">
          <div @click="handleTGoAudioShow(item.id)" class="item" v-for="item in DoctorListData" :key="item.id">
            <div class="item_top">
              <img :src="item.headImage" alt="">
              <div class="item_top_center">
                <div>{{item.doctorName}}</div>
                <span>{{item.doctorLevelName}}</span>
              </div>
            </div>
            <div class="item_bottom">
              <div class="voice_title">{{item.title}}</div>
              <div class="audio_box">
                <!--<audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">-->
                <!--</audio>-->
                <Audio :styles="{width:'189px', height:'35px'}" :url="item.url"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="article_box" v-if="this.$route.params.type == 3">
        <div class="card_leftList_centre">
          <div @click="handleGoArticleShow" class="item_List">
            <div class="list_twoBox">
              <div class="list_twoBox_Q">
                <span>小孩蛀牙吃什么药效果好？</span>
              </div>
              <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
              </div>
              <div class="list_twoBox_bottom">
                <div class="doctor_head">
                  <img src="../../assets/images/home/ceshi2.jpeg" alt="">
                  <div class="doctor_name">张三三</div>
                  <div class="doctor_hospital">北京协和医院</div>
                  <div class="doctor_twoTitle">儿科医院</div>
                </div>
              </div>
            </div>
          </div>
          <div class="item_List">
            <div class="list_twoBox">
              <div class="list_twoBox_Q">
                <span>小孩蛀牙吃什么药效果好？</span>
              </div>
              <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
              </div>
              <div class="list_twoBox_bottom">
                <div class="doctor_head">
                  <img src="../../assets/images/home/ceshi2.jpeg" alt="">
                  <div class="doctor_name">张三三</div>
                  <div class="doctor_hospital">北京协和医院</div>
                  <div class="doctor_twoTitle">儿科医院</div>
                </div>
              </div>
            </div>
          </div>
          <div class="item_List">
            <div class="list_twoBox">
              <div class="list_twoBox_Q">
                <span>小孩蛀牙吃什么药效果好？</span>
              </div>
              <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
              </div>
              <div class="list_twoBox_bottom">
                <div class="doctor_head">
                  <img src="../../assets/images/home/ceshi2.jpeg" alt="">
                  <div class="doctor_name">张三三</div>
                  <div class="doctor_hospital">北京协和医院</div>
                  <div class="doctor_twoTitle">儿科医院</div>
                </div>
              </div>
            </div>
          </div>
          <div class="item_List">
            <div class="list_twoBox">
              <div class="list_twoBox_Q">
                <span>小孩蛀牙吃什么药效果好？</span>
              </div>
              <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
              </div>
              <div class="list_twoBox_bottom">
                <div class="doctor_head">
                  <img src="../../assets/images/home/ceshi2.jpeg" alt="">
                  <div class="doctor_name">张三三</div>
                  <div class="doctor_hospital">北京协和医院</div>
                  <div class="doctor_twoTitle">儿科医院</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="answer_box" v-if="this.$route.params.type == 4">
        <div class="card_leftList_centre">
          <div class="item_List" @click="handleAnswerShow(item.id)" v-for="item in DoctorListData" :key="item.id">
            <div class="list_twoBox">
              <div class="list_twoBox_Q">
                <div>Q</div>
                <span>{{item.title}}</span>
              </div>
              <div class="list_twoBox_A">
                <div>A</div>
                <span>{{item.content}}</span>
                </div>
              <div class="list_twoBox_bottom">
                <div class="doctor_head">
                  <img :src="item.headImage" alt="">
                  <div class="doctor_name">{{item.doctorName}}</div>
                  <div class="doctor_hospital">{{item.hospitalName}}</div>
                  <div class="doctor_twoTitle">{{item.departmentName}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--分页-->
    <div class="Pagination">
      <Pagination  :pageSize="total" v-model="dataForm.page" @on-jump="jump" />
    </div>
  </div>
</template>

<script>
  import Pagination from '../../components/pagination/index'
  import Audio from '../../components/audio/Index'
  export default {
    name: "NavList",
    components:{
      Pagination,
      Audio
    },
    data(){
      return {
        total:10,  // 总分页数
        dataForm:{
          page:1,
          size:15,
        },
        DoctorListData:[],
      }
    },
    methods:{
      // 获取医生对应列表
      getDoctorList() {
        let type = this.$route.params.type
        // 视频
        if(type == 1){
          this.getVideoList()
        }
        // 音频
        if(type == 2){
          this.getAudioList()
        }
        // 问答
        if(type == 4){
          this.getAnswerList()
        }
      },
      jump(page){
        this.dataForm.page = page
        this.getDoctorList()
      },
      // 视频跳转
      handleTGoShow(id) {
        this.$router.push({path:'/kpVideo/kpVideoShow/'+id,query:{}})
      },
      // 音频跳转
      handleTGoAudioShow(id){
        this.$router.push({path:'/kpVoice/kpVoiceShow/'+id,query:{}})
      },
      //问答跳转
      handleAnswerShow(id) {
        this.$router.push({path:'/answerList/answeShow/'+id,query:{}})
      },
      getAudio(){
        let audios = document.getElementsByTagName("Audio");
        // 暂停函数
        function pauseAll() {
          var self = this;
          [].forEach.call(audios, function (i) {
            // 将audios中其他的audio全部暂停
            i !== self && i.pause();
          })
        }
        // 给play事件绑定暂停函数
        [].forEach.call(audios, function (i) {
          i.addEventListener("play", pauseAll.bind(i));
        })
      },
      // 获取视频列表
      getVideoList() {
        const data = {
          type:3,
          page:this.dataForm.page,
          size:this.dataForm.size,
          hot:false,
          doctorId:this.$route.params.id
        }
        this.$api.mykp_home.finddoctorTree(data) .then(res => {
          if(res.code == '000000'){
            this.DoctorListData = res.infos.list
            this.total = Math.ceil(res.infos.total/15)
          }
        })
      },
      // 获取语音列表
      getAudioList() {
        const data = {
          type:2,
          page:this.dataForm.page,
          size:this.dataForm.size,
          hot:false,
          doctorId:this.$route.params.id
        }
        this.$api.mykp_home.finddoctorTree(data) .then(res => {
          if(res.code == '000000'){
            this.DoctorListData = res.infos.list
            this.total = Math.ceil(res.infos.total/15)
            this.$nextTick(() => {
              this.getAudio()
            })
          }
        })
      },
      // 获取问答列表
      getAnswerList() {
        const data = {
          type:1,
          page:this.dataForm.page,
          size:this.dataForm.size,
          hot:false,
          doctorId:this.$route.params.id
        }
        this.$api.mykp_home.finddoctorTree(data) .then(res => {
          if(res.code == '000000'){
            this.DoctorListData = res.infos.list
            this.total = Math.ceil(res.infos.total/6)
          }
        })
      },
    },
    activated() {
      this.getAudio()
      // this.getDoctorList()
    },
    watch:{
      '$route.params.type':{
        handler:function (n,o) {
          this.DoctorListData = []
          this.dataForm = {
            page:1,
            size:15,
          }
          if(n == 4) {
            this.dataForm.size = 5
          }
          this.getDoctorList()
        },
        immediate:true
      },

    }
  }
</script>
<style lang="stylus" scoped>
  div{
    box-sizing border-box
  }
  .NavList{
    .NavList_center{
      .video_box{
        .home_KpVideo_Card{
          margin-top 40px
          .KpVideo_Card_list{
            display flex
            flex-wrap wrap
            .item_Card_list{
              width: 224px;
              height: 225px;
              display flex
              flex-direction column
              justify-content space-between
              padding-bottom 20px
              margin-bottom 30px
              margin-right 20px
              cursor: pointer
              &:nth-child(5n){
                margin-right 0px
              }
              &:hover{
                box-shadow:0 2px 6px 1px #eee;
              }
              .card_img{
                display flex
                flex-direction column
                >img{
                  width: 224px
                  height: 120px
                }
                >div{
                  margin-top 15px
                  padding 0 15px
                  font-size: 16px;
                  color: #5E5E5E;
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  line-height 20px
                }
                &:after{
                  content ''
                  width 100%
                  height 1px
                  border-top:1px dashed  #eee
                  margin-top 5px
                }
              }

              .card_name{
                padding 0 15px
                display flex
                justify-content space-between
                align-items center
                >div{
                  width 30%
                  font-weight: 700;
                  font-style: normal;
                  font-size: 14px;
                  color: #5E5E5E;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                >span{
                  display block
                  font-size: 12px;
                  color: #5E5E5E;
                  width 70%
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  text-align: right
                }
              }
            }
          }
        }
      }
      .audio_box{
        .voice_list{
          display flex
          flex-wrap wrap
          .item{
            margin-right 17px
            width: 224px;
            height: 284px;
            border 1px solid #8cd4a7
            border-radius: 7px;
            padding 10px 0
            margin-bottom 30px
            cursor: pointer
            &:nth-child(5n){
              margin-right 0
            }
            .item_top{
              display flex
              flex-direction column
              align-items center
              &:after{
                content ''
                display block
                width: 100%
                height: 1px
                border-top 1px dashed #eee
                margin-top 15px
              }
              >img{
                width: 135px;
                height: 135px;
                border-radius 50%
              }
              .item_top_center{
                width: 80%
                display flex
                justify-content space-around
                align-items center
                margin-top 10px
                >div{
                  max-width 60px
                  font-weight: 700;
                  font-style: normal;
                  font-size: 18px;
                  color: #000000;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                >span{
                  display block
                  max-width 70px
                  font-size: 14px;
                  color: #000000;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
            .item_bottom{
              display flex
              flex-direction column
              align-items center
              .voice_title{
                max-width 200px
                margin-top 10px
                font-size: 16px;
                color: #333
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .audio_box{
                margin-top 10px
                >audio{
                  width: 200px;
                  height: 35px;
                  outline none
                }
              }
            }
          }
        }
      }
      .article_box{
        .card_leftList_centre{
          padding 0 15px
          .item_List{
            &:after{
              content ''
              display block
              width: 100%
              height: 1px
              border-top 1px solid #eee
              margin 20px 0 25px 0
            }
            .list_twoBox{
              .list_twoBox_Q{
                display flex
                align-items center
                >span {
                  font-weight: 700;
                  font-style: normal;
                  font-size: 16px;
                  color: #333
                  cursor: pointer
                }
              }
              .list_twoBox_A{
                margin-top 10px
                display flex
                align-items center
                >span {
                  font-style: normal;
                  color: #333
                  font-size: 14px;
                  line-height: 22px;
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
              }
              .list_twoBox_bottom{
                display flex
                align-items center
                .doctor_head{
                  display flex
                  align-items center
                  margin-top 20px
                  >img{
                    width: 60px;
                    height: 60px;
                    border-radius 50%
                    margin-right 15px
                  }
                  .doctor_name{
                    font-weight: 700;
                    font-style: normal;
                    font-size: 14px;
                    color: #5E5E5E;
                    margin-right 30px
                    max-width: 90px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  .doctor_hospital{
                    font-size: 14px;
                    color: #5E5E5E;
                    margin-right 30px
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    max-width 150px
                  }
                  .doctor_twoTitle{
                    font-size: 14px;
                    color: #5E5E5E;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    max-width 150px
                  }
                }
              }
            }
          }
        }
      }
      .answer_box{
        .card_leftList_centre{
          .item_List{
            margin-bottom 25px
            cursor: pointer
            &:after{
              content ''
              display block
              width: 100%
              height: 1px
              border-top 1px dashed #eee
              margin-top 15px
            }
            .list_twoBox{
              .list_twoBox_Q{
                display flex
                align-items center
                >div{
                  width: 40px
                  height: 40px
                  border-radius: 5px;
                  background #63a3fc
                  font-weight: 700;
                  font-style: normal;
                  font-size: 20px;
                  color: #fff
                  text-align: center
                  line-height:40px
                  margin-right 20px
                }
                >span {
                  font-weight: 700;
                  font-style: normal;
                  font-size: 16px;
                  color: #333
                  cursor: pointer
                }
              }
              .list_twoBox_A{
                margin-top 20px
                display flex
                align-items center
                >div{
                  width: 40px
                  height: 40px
                  border-radius: 5px;
                  background #f57a7c
                  font-weight: 700;
                  font-style: normal;
                  font-size: 20px;
                  color: #fff
                  text-align: center
                  line-height:40px
                  margin-right 20px
                }
                >span {
                  width 95%
                  font-style: normal;
                  color: #333
                  font-size: 14px;
                  line-height: 22px;
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 4;
                  -webkit-box-orient: vertical;
                }
              }
              .list_twoBox_bottom{
                display flex
                align-items center
                .doctor_head{
                  display flex
                  align-items center
                  margin-top 20px
                  >img{
                    width: 60px;
                    height: 60px;
                    border-radius 50%
                    margin-right 15px
                  }
                  .doctor_name{
                    font-weight: 700;
                    font-style: normal;
                    font-size: 14px;
                    color: #5E5E5E;
                    margin-right 15px
                    max-width: 90px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  .doctor_hospital{
                    font-size: 14px;
                    color: #5E5E5E;
                    margin-right 15px
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    max-width 150px
                  }
                  .doctor_twoTitle{
                    font-size: 14px;
                    color: #5E5E5E;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    max-width 150px
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .Pagination{
    margin-top 20px
  }
</style>





// WEBPACK FOOTER //
// src/views/salientDoctor/NavList.vue